import type { AccountInfo } from "@azure/msal-browser";

import rxcallLogo from "~/assets/rxcall-logo.svg";
import { LocationSelector } from "~/shared/components/LocationSelector";

interface HeaderProps {
  readonly user: AccountInfo;
}

export function Header({ user }: HeaderProps) {
  const displayName = user.name ?? user.username ?? '';


  return (
    <header>
      <div className="brand">
        <img src={rxcallLogo} alt="RxDial Logo" className="brand-logo" />
        <div>
          <div className="brand-subtitle">Last Mile Delivery</div>
        </div>
      </div>
      <div className="status-badges">
        <div style={{ marginRight: 16 }}>
          <LocationSelector />
        </div>
        <div className="user-menu">
          <div className="user-avatar">
            {displayName.charAt(0).toUpperCase()}
          </div>
          <span className="user-name">{displayName}</span>
        </div>
        <a
          href="/auth/logout"
          className="btn"
          style={{ marginLeft: 8, textDecoration: 'none' }}
        >
          Sign out
        </a>
      </div>
    </header>
  );
}
